let routes = [{
		path: '/',
		name: 'layout',
		redirect: {
			name: 'index'
		},
		component: 'layout',
		children: [
			{
				meta:{title:'後台首頁'},
				component: 'index/index'
			},
			{
				meta:{title:'學校首頁'},
				component: 'school/index'
			},
			{
				meta:{title:'APP設置'},
				component: 'set/base/index'
			},
			{
				meta:{title:'帳號角色管理'},
				component: 'set/manager/index'
			},
			{
				meta:{title:'添加角色'},
				component: 'set/manager/rule'
			},
			{
				meta:{title:'管理員列表'},
				component: 'set/admin/index'
			},
			{
				meta:{title:'系統公告'},
				component: 'data/notice'
			},
			{
				meta:{title:'學校列表'},
				component: 'school/school'
			},
			{
				meta:{title:'地區列表'},
				component: 'data/address'
			},
			{
				meta:{title:'機構列表'},
				component: 'data/institution'
			},
			{
				meta:{title:'寄件箱'},
				component: 'data/email'
			},
			{
				meta:{title:'收件箱'},
				component: 'data/emailreply'
			},
			{
				meta:{title:'公仔管理'},
				component: 'data/userset'
			},
			{
				meta:{title:'科目配置'},
				component: 'data/subject'
			},
			{
				meta:{title:'年級設置'},
				component: 'data/grade'
			},
			{
				meta:{title:'科目類別標籤'},
				component: 'data/label'
			},
			{
				meta:{title:'用户标签'},
				component: 'data/userLabel'
			},
			{
				meta:{title:'全部郵件'},
				component: 'data/useremail'
			},
			{
				meta:{title:'用戶名片'},
				component: 'user/userinfo'
			},
			{
				meta:{title:'用戶列表'},
				component: 'data/user'
			},
			{
				meta:{title:'學生重置密碼申請'},
				component: 'data/resetpass'
			},
			{
				meta:{title:'參數設置'},
				component: 'data/classify'
			},
			{
				meta:{title:'任務列表'},
				component: 'data/task'
			},
			{
				meta:{title:'比賽記錄'},
				component: 'data/taskrecord'
			},
			{
				meta:{title:'題目列表'},
				component: 'data/topic'
			},
			{
				meta:{title:'答題記錄'},
				component: 'user/topic'
			},
			{
				meta:{title:'機器人管理'},
				component: 'user/robot'
			},
			{
				meta:{title:'比賽結果審核'},
				component: 'user/check'
			},
			{
				meta:{title:'等級管理'},
				component: 'user/level'
			},
			{
				meta:{title:'購物車'},
				component: 'data/cart'
			},
			{
				meta:{title:'訂單記錄'},
				component: 'order/userorder'
			},
			{
				meta:{title:'任務記錄'},
				component: 'user/task'
			},
			{
				meta:{title:'學校帳號'},
				component: 'school/account'
			},
			{
				meta:{title:'老師管理'},
				component: 'school/teacher'
			},
			{
				meta:{title:'金幣記錄'},
				component: 'user/cion'
			},
			{
				meta:{title:'鑽石記錄'},
				component: 'user/diamond'
			},
			{
				meta:{title:'畢業用戶名單'},
				component: 'user/enduser'
			},
			{
				meta:{title:'比賽發佈審核'},
				component: 'user/compublish'
			},
			{
				meta:{title:'登錄日誌'},
				component: 'user/loginlog'
			},
			{
				meta:{title:'404錯誤'},
				component: 'error/404'
			}
		]
	},
	{
		// path:'/login',
		// name:'login',
		//component:()=>import('../../views/login/index.vue')
		meta:{title:'登錄页'},
		component: 'login/index'
	},
	{
		path: '*',
		redirect: {
			name: 'index'
		}
	}
]
// 获取路由信息方法
let getRoutes = function() {
	// 生成路由详细信息
	createRoute(routes)
	return routes
}
// 自动生成路由
function createRoute(arr) {
	for (let i = 0; i < arr.length; i++) {
		if (!arr[i].component) return
		// 去除index
		let val = getValue(arr[i].component)
		// 生成name
		arr[i].name = arr[i].name || val.replace(/\//g, '_')
		// 生成apth
		arr[i].path = arr[i].path || `/${val}`
		// 自动生成component
		let componentFun = import(`../../views/${arr[i].component}.vue`)
		arr[i].component = () => componentFun
		if (arr[i].children && arr[i].children.length > 0) {
			createRoute(arr[i].children)
		}
	}
}
// 去除index
function getValue(str) {
	// str = login/index
	// 获取最後一个/索引
	let index = str.lastIndexOf('/')
	// 获取最後一个/後面的值
	let val = str.substring(index + 1, str.length)
	// 判断是不是index结尾
	if (val === 'index') {
		return str.substring(index, -1)
	}
	return str
}
export default getRoutes()
